import React, {useEffect, useState} from "react";
import AppColors from "../colors/AppColors";
import {InlineIcon} from "@iconify/react";
import BitcoinIcon from '@iconify/icons-mdi/bitcoin';
import {Avatar, makeStyles, Menu, MenuItem, Typography, CircularProgress} from "@material-ui/core";
import {grey} from '@material-ui/core/colors';
import {useSelector, RootStateOrAny} from "react-redux";
import {Constants} from "../constants/Constants";
import UsersManager from "../managers/UsersManager";
import axios from "axios";
import EndPoints from "../net/EndPoints";
import MaterialSnackBar from "../views/MaterialSnackBar";
import {Redirect} from "react-router-dom";
import Routes from "../constants/Routes";

const useBalanceViewStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: AppColors.APP_BAR_BACKGROUND_COLOR,
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: AppColors.lightenOrDarken(AppColors.APP_BAR_BACKGROUND_COLOR, 10)
        }
    }
}));

export default function BalanceView() {

    const balanceClasses = useBalanceViewStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const isMenuOpen = Boolean(anchorEl);
    const [openSnack, setOpenSnack] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [snackSeverity, setSnackSeverity] = useState("warning");
    const [loggedOut, setLoggedOut] = useState(false);
    const [attemptingLogOut, setAttemptingLogOut] = useState(false);
    const [loggedInUserCredentialsChanged, setLoggedInUserCredentialsChanged] = useState(false);

    const loggedInUserString: string | undefined = useSelector((state: RootStateOrAny) => {
        let liveUserData = state.appReducer[Constants.LOGGED_IN_USER_DATA];
        if (!liveUserData) {
            liveUserData = UsersManager.getLoggedInUser() as string;
        }
        return liveUserData;
    });

    const loggedInUser = loggedInUserString ? JSON.parse(loggedInUserString) : undefined;

    const handleSnackClose = () => {
        setOpenSnack(false);
    }

    const snackError = (message: string) => {
        setSnackMessage(message);
        setSnackSeverity("error");
        setOpenSnack(true);
    }

    const menuId = 'logged_in_user_options_menu';

    enum MenuAction {
        PROFILE,
        TRANSACTIONS,
        REFERRALS,
        LOGOUT
    }

    const handleMenuClose = (menuAction: MenuAction) => {
        setAnchorEl(null);
        if (menuAction === MenuAction.LOGOUT) {
            const headers = {
                [Constants.API_KEY]: loggedInUser.apiKey
            };
            setAttemptingLogOut(true);
            axios.post(EndPoints.LOGOUT, {}, {
                headers: headers
            }).then(data => {
                UsersManager.deleteLoggedInUser();
                setLoggedInUserCredentialsChanged(true);
            }).catch(error => {
                let errorResponseData = error.response["data"]
                let message = errorResponseData["message"] ?? "Error completing log out. Please try again";
                snackError(message);
            });
        } else if (menuAction == MenuAction.PROFILE) {
            window.location.href = Routes.PROFILE
        } else if (menuAction === MenuAction.REFERRALS) {
            window.location.href = Routes.REFERRALS
        } else if (menuAction === MenuAction.TRANSACTIONS) {
            window.location.href = Routes.TRANSACTIONS
        }
    };

    useEffect(() => {
        if (loggedInUserCredentialsChanged) {
            UsersManager.deleteLoggedInUser();
            setLoggedOut(true);
        }
    }, [loggedInUserCredentialsChanged]);

    const handleProfileMenuOpen = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{vertical: 'top', horizontal: 'right'}}
            id={menuId}
            keepMounted
            transformOrigin={{vertical: 'top', horizontal: 'right'}}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={() => handleMenuClose(MenuAction.PROFILE)}>Profile</MenuItem>
            <MenuItem onClick={() => handleMenuClose(MenuAction.TRANSACTIONS)}>Transactions</MenuItem>
            <MenuItem onClick={() => handleMenuClose(MenuAction.REFERRALS)}>Referrals</MenuItem>
            <MenuItem onClick={() => handleMenuClose(MenuAction.LOGOUT)}>Log Out</MenuItem>
        </Menu>
    );

    return (
        loggedOut ?
            <Redirect to={Routes.DEFAULT}/>
            :
            <div
                className={balanceClasses.root}
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>
                {
                    attemptingLogOut &&
                    <CircularProgress color="inherit" size={20} style={{
                        marginRight: 10,
                        color: 'white'
                    }}/>
                }
                <InlineIcon icon={BitcoinIcon} width={25} height={25} style={{
                    color: AppColors.ACCENT_COLOR
                }}/>
                <Typography
                    onClick={handleProfileMenuOpen}
                    style={{marginLeft: 1, color: grey[200], fontWeight: 600, fontSize: 20}}
                    dangerouslySetInnerHTML={{__html: `<span style='font-size:20px;'>${loggedInUser ? loggedInUser.balance.toFixed(8) : '0.00000000'}</span>`}}/>
                <Avatar
                    onClick={handleProfileMenuOpen}
                    style={{
                        width: 35,
                        height: 35,
                        alignSelf: 'center',
                        marginLeft: 20,
                        marginRight: 20,
                        fontWeight: 600,
                        backgroundColor: AppColors.ACCENT_COLOR
                    }}>
                    {
                        loggedInUser ? loggedInUser.email.charAt(0).toUpperCase() : ""
                    }
                </Avatar>
                {renderMenu}
                <MaterialSnackBar open={openSnack} onSnackClosed={handleSnackClose} message={snackMessage}
                                  severity={snackSeverity}/>
            </div>
    );
}